import {each} from 'underscore';
import xhr from './Xhr';

const CLASSES = {
    login_form_wrapper: 'js-login-form-wrapper',
    form_wrapper: 'js-request-password-form-wrapper',
    trigger: {
        click: 'js-request-password-render',
        submit: 'js-request-password-subscriber'
    }
};

const INPUTNAMES = {
    username: 'username'
};

const touchEvent = 'ontouchend' in window ? 'touchend' : 'click';


export default function requestPasswordSubscriber() {
    addRenderEventListener();
    addSubmitEventListener();
}

function addSubmitEventListener() {
    each(document.querySelectorAll(`.${CLASSES.trigger.submit}`),
        (el) => {
            el.addEventListener('submit',
                (event) => submitForm(event));
        });
}

export function addRenderEventListener() {
    each(document.querySelectorAll(`.${CLASSES.trigger.click}`),
        (el) => {
            el.addEventListener(touchEvent,
                (event) => renderForm(event));
        });
}

function renderForm(event) {
    event.preventDefault();

    const button = event.currentTarget;
    const url = button.getAttribute('data-href');

    xhr.get(url).then((request) => {
        const response = request.responseText;
        const wrapper = document.querySelectorAll(`.${CLASSES.login_form_wrapper}`)[0];

        if (typeof wrapper !== 'undefined') {
            wrapper.outerHTML = response;
        }

        reloadEventListeners();
    });
}

function submitForm(event) {
    event.preventDefault();

    const checkbox = event.target;
    const form = checkbox.closest('form');

    const url = form.getAttribute('action');

    if (url) {
        // Build data params
        let data = '';
        each(INPUTNAMES, (inputField) => {
            const el = form.querySelector(`[name="${inputField}"]`);
            if (el === null) {
                return;
            }

            let value;

            if (el.type === 'checkbox') {
                if (el.checked) {
                    value = el.checked;
                }
            } else {
                value = form.querySelector(`[name="${inputField}"]`).value;
            }
            if (value) {
                data += `${inputField}=${value}&`;
            }
        });

        xhr.post(url, data).then((request) => {
            const response = request.responseText;
            const wrapper = document.querySelectorAll(`.${CLASSES.form_wrapper}`)[0];

            if (typeof wrapper !== 'undefined') {
                wrapper.innerHTML = response;
            }

            reloadEventListeners();
        });
    }
}

export function reloadEventListeners() {
    addSubmitEventListener();
    addRenderEventListener();
}



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/RequestPasswordSubscriber.js